(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nbd-size-preference"] && !Shopify.designMode) return;
  try {
    NBD.onLoad(() => {
  if (customElements.get('nbd-size-preference')) return;

  class NBDSizePreference extends HTMLElement {
    connectedCallback() {
      // The nearest picker, so a quick buy copy inside another section finds its own.
      let container = this.parentElement;
      while (container && !container.querySelector('variant-picker')) container = container.parentElement;
      this.picker = container && container.querySelector('variant-picker');
      if (!this.picker) return;

      this._optionData = JSON.parse(this.dataset.options || '[]').map(opt => this._parseOptionData(opt));
      if (!this._optionData.length) {
        this.picker.classList.add('nbd-size-preference-ready');
        return;
      }

      this._preferredKey = this.dataset.preferredKey || null;

      const variantBlock = this.picker.closest('[data-dynamic-variant-content]');
      if (variantBlock) {
        this._variantWrapper = document.createElement('div');
        this._variantWrapper.className = 'nbd-size-preference-block-wrapper';
        this._variantWrapper.id = `nbd-size-preference-${++NBDSizePreference.count}`;
        variantBlock.parentNode.insertBefore(this._variantWrapper, variantBlock);
        this._variantWrapper.appendChild(variantBlock);

        // Symmetry swaps in a new picker on variant change. Relabelling it in a
        // microtask, before layout, stops the full labels causing a layout shift.
        const observer = new MutationObserver(mutations => {
          for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
              if (node.nodeType !== Node.ELEMENT_NODE || !node.hasAttribute('data-dynamic-variant-content')) continue;
              const newPicker = node.querySelector('variant-picker');
              if (newPicker) { this.picker = newPicker; this.refresh(); }
              return;
            }
          }
        });
        observer.observe(this._variantWrapper, { childList: true });
      }

      this.groups = new Map();
      this._note = this.querySelector('.nbd-size-preference-note');
      if (this._note && this._variantWrapper) this._variantWrapper.insertAdjacentElement('afterend', this._note);
      this._scheduleReveal();
      this.init();

      container.addEventListener('on:variant:change', () => clearTimeout(this._revealTimer));
    }

    _parseOptionData(opt) {
      const keys = [];
      const map = {};
      const seenKeys = new Set();
      opt.values.forEach(v => {
        if (!v.includes('/')) return;
        map[v] = {};
        v.split('/').forEach(seg => {
          const parts = seg.trim().split(/\s+/);
          const key = parts.slice(0, -1).join(' ');
          const val = parts.at(-1);
          if (key) {
            map[v][key] = val;
            if (!seenKeys.has(key)) { seenKeys.add(key); keys.push(key); }
          }
        });
      });
      return { ...opt, keys, map };
    }

    init() {
      this._optionData.forEach(optData => {
        const selector = this.picker.querySelector(`.option-selector[data-index="${optData.index}"]`);
        if (selector) this.processSelector(selector, optData);
      });
    }

    refresh() {
      this._optionData.forEach(optData => {
        const selector = this.picker.querySelector(`.option-selector[data-index="${optData.index}"]`);
        if (!selector) return;
        const groupKey = `${optData.option}:${optData.index}`;
        const group = this.groups.get(groupKey);
        if (!group) return;
        group.selector = selector;
        this.valueSpans(selector, group.isDropdown).forEach(el => {
          const cur = el.textContent.trim();
          if (group.map[cur]) el.dataset.nbdOriginal = cur;
        });
        this.applyKey(group);
      });
    }

    processSelector(selector, optData) {
      const isDropdown = selector.dataset.selectorType === 'dropdown';
      const groupKey = `${optData.option}:${optData.index}`;
      let group = this.groups.get(groupKey);

      if (!group) {
        const preferred = this._preferredKey;
        const activeKey = (preferred && optData.keys.includes(preferred)) ? preferred : optData.keys[0];
        group = { keys: optData.keys, map: optData.map, label: optData.option, activeKey, isDropdown };
        this.groups.set(groupKey, group);
      }

      group.selector = selector;

      this.valueSpans(selector, isDropdown).forEach(el => {
        const cur = el.textContent.trim();
        if (group.map[cur]) el.dataset.nbdOriginal = cur;
      });

      const variantBlock = this.picker.closest('[data-dynamic-variant-content]');
      if (variantBlock && !variantBlock.previousElementSibling?.classList.contains('nbd-size-preference-tabs')) {
        this.injectTabs(group, variantBlock);
      }

      this.applyKey(group);
    }

    valueSpans(selector, isDropdown) {
      return isDropdown
        ? [...selector.querySelectorAll('.custom-select__option > span.pointer-events-none')]
        : [...selector.querySelectorAll('.js-value')];
    }

    applyKey(group) {
      const { activeKey, selector, isDropdown, map } = group;

      this.valueSpans(selector, isDropdown).forEach(el => {
        const src = el.dataset.nbdOriginal;
        if (!src || !map[src]) return;
        const val = map[src][activeKey];
        if (val && el.textContent !== val) el.textContent = val;
      });

      if (isDropdown) {
        const btn = selector.querySelector('.custom-select__btn > span.text-start');
        if (btn) {
          const cur = btn.textContent.trim();
          if (map[cur]) btn.dataset.nbdOriginal = cur;
          const val = map[btn.dataset.nbdOriginal]?.[activeKey];
          if (val && btn.textContent !== val) btn.textContent = val;
        }
      }
    }

    activateTab(group, tab) {
      const tabList = tab.closest('[role="tablist"]');
      tabList.querySelectorAll('[role="tab"]').forEach(t => {
        t.setAttribute('aria-selected', 'false');
        t.setAttribute('tabindex', '-1');
      });
      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');
      tab.focus();
      group.activeKey = tab.dataset.key;
      this.applyKey(group);
    }

    injectTabs(group, variantBlock) {
      const wrapper = document.createElement('div');
      wrapper.className = 'nbd-size-preference-tabs';

      const labelEl = document.createElement('span');
      labelEl.className = 'nbd-size-preference-tabs__label label';
      labelEl.textContent = group.label;
      wrapper.appendChild(labelEl);

      const tabList = document.createElement('div');
      tabList.className = 'nbd-size-preference-tabs__list';
      tabList.setAttribute('role', 'tablist');
      wrapper.appendChild(tabList);

      group.keys.forEach(key => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'nbd-size-preference-tabs__tab';
        btn.setAttribute('role', 'tab');
        const isActive = key === group.activeKey;
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.setAttribute('tabindex', isActive ? '0' : '-1');
        btn.dataset.key = key;
        btn.textContent = key;
        tabList.appendChild(btn);
      });

      tabList.addEventListener('click', evt => {
        const tab = evt.target.closest('[role="tab"]');
        if (!tab || tab.getAttribute('aria-selected') === 'true') return;
        this.activateTab(group, tab);
      });

      tabList.addEventListener('keydown', evt => {
        const tabs = [...tabList.querySelectorAll('[role="tab"]')];
        const i = tabs.findIndex(t => t.getAttribute('aria-selected') === 'true');
        let next = -1;
        if (evt.key === 'ArrowRight') { evt.preventDefault(); next = (i + 1) % tabs.length; }
        else if (evt.key === 'ArrowLeft') { evt.preventDefault(); next = (i - 1 + tabs.length) % tabs.length; }
        else if (evt.key === 'Home') { evt.preventDefault(); next = 0; }
        else if (evt.key === 'End') { evt.preventDefault(); next = tabs.length - 1; }
        if (next >= 0) this.activateTab(group, tabs[next]);
      });

      variantBlock.insertAdjacentElement('beforebegin', wrapper);
    }

    _captureButtonWidths() {
      if (!this._variantWrapper || !this._style) return;
      const id = CSS.escape(this._variantWrapper.id);
      const rules = [];
      this._optionData.forEach(opt => {
        this._variantWrapper.querySelectorAll(
          `[data-index="${opt.index}"] .option-selector__btns > label.opt-label--btn`
        ).forEach((label, i) => {
          const width = label.getBoundingClientRect().width;
          if (width) rules.push(
            `#${id} [data-index="${opt.index}"] .option-selector__btns>label.opt-label--btn:nth-of-type(${i + 1}){width:${width}px;overflow:hidden}`
          );
        });
      });
      if (rules.length) this._style.textContent += rules.join('');
    }

    _scheduleReveal() {
      clearTimeout(this._revealTimer);
      const picker = this.picker;
      this._revealTimer = setTimeout(() => picker.classList.add('nbd-size-preference-ready'), 2000);
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (this._variantWrapper) {
          const id = CSS.escape(this._variantWrapper.id);
          const visHidden = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap';
          const labelRules = this._optionData.map(opt =>
            `#${id} [data-index="${opt.index}"] label.label,#${id} [data-index="${opt.index}"] legend.label{${visHidden}}`
          ).join('');
          this._style = document.createElement('style');
          document.head.appendChild(this._style);
          this._style.textContent = `#${id}{min-height:${this._variantWrapper.offsetHeight}px}${labelRules}`;
          this._captureButtonWidths();
        }
        clearTimeout(this._revealTimer);
        picker.classList.add('nbd-size-preference-ready');
        if (this._variantWrapper) this._variantWrapper.classList.add('nbd-size-preference-initialized');
      }));
    }
  }

  NBDSizePreference.count = 0;
  customElements.define('nbd-size-preference', NBDSizePreference);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nbd-swatch"] && !Shopify.designMode) return;
  try {
    NBD.onLoad(() => {
    if (customElements.get('nbd-swatch')) return;

    class NBDSwatch extends HTMLElement {
      constructor() {
        super();
        this.max = 512;
        this.ttl = 5 * 60 * 1000;
        this.handle = this.dataset.handle;
        // Availability differs by market, so cache per country.
        this.key = `${window.Shopify?.country || ''}:${this.handle}`;
      }

      connectedCallback() {
        this.render();
      }

      productUrl(handle) {
        const base = window.Shopify?.routes?.root || '/';
        return `${base}products/${handle}`;
      }

      update(ok) {
        this.toggleAttribute('data-show', ok);
        this.toggleAttribute('data-hide', !ok);
      }

      async render() {
        this.store = NBD.cache('Swatch', this.max);

        if (this.store.has(this.key)) {
          this.update(this.store.get(this.key));
          return;
        }

        try {
          const res = await fetch(this.productUrl(this.handle), { method: 'HEAD' });
          // Only a definite answer is cached; other errors may be transient.
          if (res.ok || res.status === 404) {
            this.store.put(this.key, res.ok, this.ttl);
          }
          this.update(res.ok);
        } catch {
          this.update(false);
        }
      }
    }

    customElements.define('nbd-swatch', NBDSwatch);
  });
  } catch(e) { console.error(e); }
})();

})();
